import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBaseNewURL } from 'services/getBaseURL';
import HttpClient from 'services/HttpClient';
import { getUserToken } from 'services/utils';

const baseUrl = `${getBaseNewURL().customize}`;
const http = new HttpClient();
// let guestToken = 'bearer 496A94E4-5B3D-4394-98BF-12F1C14852D7';

const initialState = {
	isLoading: {
		backdrop: false,
		form: false,
		skeleton: false,
		button: false,
	},
	bankInQuiry: {},
	isCredit: false,
	requestCredit: {},
	isRedirect: false,
	isError: {
		status: false,
		message: '',
	},
};

export const getMehrBankInquiry = createAsyncThunk('mehrbankinquiry', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	// Notice : Don't Remove Token
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http
		.post(`${baseUrl}mehrkalacard/mehrbankinquiry`, params, extraConfig)

		.then((res) => {
			return res.data;
		});
	return response;
});

export const setSubmitCredit = createAsyncThunk('SubmitCredit', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const { isToastfy, ...restParams } = params;

	// Notice : Don't Remove Token
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http
		.post(`${baseUrl}mehrkalacard/SubmitCredit`, restParams, extraConfig, isToastfy)

		.then((res) => {
			return res.data;
		});
	return response;
});

export const getUserRequestedCredit = createAsyncThunk(
	'GetUserRequestedCreditDetails',
	async (params, thunkAPI) => {
		let token = getUserToken(thunkAPI);

		// Notice : Don't Remove Token
		const extraConfig = {
			headers: {
				'Authorization': token,
			},
		};
		const response = await http
			.post(`${baseUrl}mehrkalacard/GetUserRequestedCreditDetails`, params, extraConfig)

			.then((res) => {
				return res.data;
			});
		return response;
	},
);

export const setFacilityRegistration = createAsyncThunk(
	'setFacilityRegistration',
	async (params, thunkAPI) => {
		let token = getUserToken(thunkAPI);

		// Notice : Don't Remove Token
		const extraConfig = {
			headers: {
				'Authorization': token,
			},
		};
		const response = await http
			.post(`${baseUrl}MehrKalaCard/FacilityRegistration`, params, extraConfig)

			.then((res) => {
				return res.data;
			});

		return response;
	},
);

const _createMehrSlice = createSlice({
	name: 'mehr',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getMehrBankInquiry.pending, (state) => {
				state.isLoading.button = true;
				state.isLoading.skeleton = true;
			})
			.addCase(getMehrBankInquiry.fulfilled, (state, action) => {
				const { Success, Content, Status } = action.payload;

				if (Success) {
					state.bankInQuiry = Content;
				}

				if ([679].includes(Status)) {
					state.isRedirect = true;
				}

				state.isLoading.button = false;
				state.isLoading.skeleton = false;
			})
			.addCase(getMehrBankInquiry.rejected, (state, action) => {
				const { Status } = action.payload;

				state.isLoading.button = false;
				state.isLoading.skeleton = false;

				if ([679].includes(Status)) {
					state.isRedirect = true;
				}
			})
			.addCase(setSubmitCredit.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(setSubmitCredit.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.isCredit = Content?.isSuccess;
				}
				state.isLoading.button = false;
			})
			.addCase(setSubmitCredit.rejected, (state) => {
				state.isLoading.button = false;
			})
			.addCase(getUserRequestedCredit.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(getUserRequestedCredit.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.requestCredit = Content;
				}
				state.isLoading.button = false;
			})
			.addCase(getUserRequestedCredit.rejected, (state) => {
				state.isLoading.button = false;
			})
			.addCase(setFacilityRegistration.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(setFacilityRegistration.fulfilled, (state, action) => {
				const { Status, Message } = action.payload;
				state.isLoading.skeleton = false;

				// eslint-disable-next-line no-console
				console.log('mehr request', [200].includes(Status), Status, Message);

				if (![200].includes(Status)) {
					state.isError.status = true;
					state.isError.message = Message;
				} else if ([200].includes(Status)) {
					state.isError.status = false;
					state.isError.message = Message;
				}
			})
			.addCase(setFacilityRegistration.rejected, (state) => {
				state.isLoading.skeleton = false;

				state.isError.status = true;
			});
	},
});

// export const { } = _createMehrSlice.actions;
export default _createMehrSlice.reducer;
